import { Container, Heading, Link, Text } from "@chakra-ui/react";

export function meta() {
  return [
    {
      title: "Terms and Conditions - Car Crushers",
    },
  ];
}

export default function () {
  return (
    <Container maxW="container.lg" pb="8vh" pt="4vh" textAlign="start">
      <Heading>Terms and Conditions</Heading>
      <br />
      <Text>Last Updated: 2023-09-07</Text>
      <br />
      <Text>Yes, we know this shit is boring to read, but it's important.</Text>
      <br />
      <hr />
      <br />
      <Text>These terms govern your use of the Car Crushers website.</Text>
      <br />
      <Text>
        You would think people have common sense but sadly many don't.
      </Text>
      <br />
      <Text>For this reason, we have to create this document.</Text>
      <br />
      <br />
      <Heading size="lg">Definitions</Heading>
      <br />
      <ul>
        <li>We, Us: Wells Studios (the operator of this website)</li>
        <li>You: The person currently reading this document</li>
      </ul>
      <br />
      <br />
      <Heading size="lg">General Rules</Heading>
      <br />
      <ul>
        <li>Do not upload malicious files to this site</li>
        <li>Do not submit spam using forms on this site</li>
        <li>Do not upload any content illegal under the laws of Sweden</li>
        <li>You must be at least 13 years old to use this site</li>
        <li>
          You may not automate access to this site by any means (except a public
          search crawler if you operate one)
        </li>
        <li>
          You may not falsely imply that you are affiliated with or endorsed by
          Wells Studios
        </li>
        <li>
          <Link color="#646cff" href="/files/why.jpg" target="_blank">
            All visitors from New Jersey must explain why
          </Link>
        </li>
      </ul>
      <br />
      <br />
      <Heading size="lg">Enforcement</Heading>
      <br />
      <Text>
        We may investigate and prosecute violations of these terms to the
        fullest legal extent. We may notify and cooperate with law enforcement
        authorities in prosecuting violations of the law and these terms.
      </Text>
      <br />
      <br />
      <Heading size="lg">Your Content</Heading>
      <br />
      <Text>
        Nothing in these terms grant us ownership rights to any content that you
        submit to this site. Nothing in these terms grants you ownership rights
        to our intellectual property either. Any content you submit to this site
        is your responsibility. Content you submit to us belongs to you. But at
        a minimum, you license us to store the content and display it to
        authorized users.
      </Text>
      <br />
      <br />
      <Heading size="lg">Warranty and Disclaimer</Heading>
      <br />
      <Text>
        WE DO NOT GUARANTEE A BUG-FREE SITE, THAT IS IMPOSSIBLE. THERE IS
        ABSOLUTELY NO WARRANTY WHATSOEVER, EXPRESS OR IMPLIED. YOUR USE OF THIS
        SITE IS AT YOUR OWN RISK. THERE ARE NO GUARANTEES ON ANYTHING, NOT EVEN
        THAT THIS SITE WILL EXIST TOMORROW.
      </Text>
      <br />
      <br />
      <Heading size="lg">Termination</Heading>
      <br />
      <Text>
        We may terminate or suspend your access to the Service immediately,
        without prior notice or liability, under our sole discretion, for any
        reason whatsoever and without limitation, including but not limited to a
        breach of the Terms.
      </Text>
      <br />
      <Text>
        The contract is fully terminated when all user data (including every
        copy of every file uploaded) is fully deleted from our service.
      </Text>
      <br />
      <br />
      <Heading size="lg">Indemnification</Heading>
      <br />
      <Text>
        You agree to defend, indemnify and hold harmless Wells Studios AB and
        its licensee and licensors, and their employees, contractors, agents,
        officers and directors, from and against any and all claims, damages,
        obligations, losses, liabilities, costs or debt, and expenses (including
        but not limited to attorney's fees), resulting from or arising out of a)
        your use and access of the Service, or b) a breach of these Terms.
      </Text>
      <br />
      <br />
      <Heading size="lg">Governing Law</Heading>
      <br />
      <Text>
        These terms shall be governed and construed in accordance with the laws
        of Västmanland, Sweden.
      </Text>
    </Container>
  );
}
